import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star, ArrowRight } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

interface Testimonial {
  id: string;
  client_name: string;
  quote: string;
  session_type: string | null;
  rating: number;
}

export function TestimonialHighlight() {
  const [testimonial, setTestimonial] = useState<Testimonial | null>(null);

  useEffect(() => {
    async function fetchFeatured() {
      const { data } = await supabase
        .from('testimonials')
        .select('id, client_name, quote, session_type, rating')
        .eq('is_featured', true)
        .order('display_order', { ascending: true })
        .limit(1);

      if (data && data.length > 0) {
        setTestimonial(data[0]);
      }
    }
    fetchFeatured();
  }, []);

  if (!testimonial) return null;

  return (
    <section className="py-12 bg-card border-b border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <div className="flex justify-center gap-1 mb-4">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`h-4 w-4 ${
                  i < testimonial.rating ? 'text-primary fill-primary' : 'text-muted-foreground/30'
                }`}
              />
            ))}
          </div>
          <blockquote className="font-serif text-lg md:text-xl text-foreground/90 italic leading-relaxed mb-4">
            "{testimonial.quote}"
          </blockquote>
          <p className="text-sm text-muted-foreground">
            — {testimonial.client_name}
            {testimonial.session_type && (
              <span className="text-primary"> · {testimonial.session_type}</span>
            )}
          </p>
          <Link
            to="/portfolio"
            className="inline-flex items-center gap-1 text-sm text-primary mt-4 hover:underline"
          >
            See their session <ArrowRight className="h-3 w-3" />
          </Link>
        </div>
      </div>
    </section>
  );
}
